import { createContext, useContext, useState, useEffect } from 'react';

const PayrollAuthContext = createContext(null);

export function PayrollAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('payroll_token');
    const saved = localStorage.getItem('payroll_user');
    if (token && saved) {
      try {
        setUser(JSON.parse(saved));
      } catch {}
    }
    setLoading(false);
  }, []);

  function login(token, userData) {
    localStorage.setItem('payroll_token', token);
    localStorage.setItem('payroll_user', JSON.stringify(userData));
    setUser(userData);
  }

  function logout() {
    localStorage.removeItem('payroll_token');
    localStorage.removeItem('payroll_user');
    setUser(null);
  }

  function getToken() {
    return localStorage.getItem('payroll_token');
  }

  return (
    <PayrollAuthContext.Provider value={{ user, loading, login, logout, getToken }}>
      {children}
    </PayrollAuthContext.Provider>
  );
}

export function usePayrollAuth() {
  return useContext(PayrollAuthContext);
}

export function payrollFetch(url, options = {}) {
  const token = localStorage.getItem('payroll_token');
  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
}
